module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN308_25950915.cd899020.png";